.card {
  background: none;
  display: block;
  padding: 6px 10px;
  margin-bottom: 8px;
  cursor: pointer;
  border: 0;
  display: flex;
  gap: 8px;
  text-align: left;
  font-size: 16px;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #fafafa;

  span {
    padding-top: 2px;
  }


  &:hover {
    background-color: var(--normal-bg);
    font-weight: bold;
    border: 1px solid #808084;
    transform: scale(1.03);
  }
}